









































import OSS from "ali-oss";
import { getOSSConfig } from "@/api/ossImageUploader";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop() originUrl!: string;
  @Prop() originStatus!: string;
  @Prop() receiveResource!: string; // 控制加载进度显示与加载文案
  @Prop({
    type: String,
    default: ".jpg,.jpeg,.JPEG,.JPG,.png,.PNG,.gif,.mp4,.mov,.MOV",
  })
  accept!: string;
  @Prop({ type: Number, default: 2 }) sizeLimit!: number; //默认为2
  @Prop({ type: String, default: "image" }) mode!: string; // mode默认为image，为图片模式，鼠标上移有交互；button时是按钮模式。
  prefix = "";
  cdn_url = "";
  callback = {};
  type: any = "";
  uploading: boolean = false; // 加载状态
  showProgress: boolean = false; // 加载进度条
  percent: any = 0;
  checkpoint: any = {};
  // 回传的数据
  uploadResult: any = {
    client: null,
    file: "",
  };
  // 每次变化时，将 uploading 置为 false，处理视频回传时的空白间隔
  @Watch("receiveResource")
  onChange() {
    this.uploading = false;
    this.percent = 0;
  }
  // 当资源获取完之后，通知父组件
  @Watch("uploading")
  onChange1() {
    this.$emit("uploading", this.uploading);
  }
  chooseImg(e: any) {
    const self = this as any;
    self.$emit("choose", e);
    getOSSConfig()
      .then((res: any) => {
        // 注意前缀路径prefix的值每次请求token时都会改变，所以同一个上传请求不需要重新请求token，实现覆盖上传
        // 不同上传请求则需要每次重新获取token
        if (res.error_code == 0) {
          self.prefix = res.data.object_name_prefix;
          self.cdn_url = res.data.cdn_url;
          self.callback = res.data.callback;
          self.uploadResult.client = new OSS({
            accessKeyId: res.data.access_key_id,
            accessKeySecret: res.data.access_key_secret,
            stsToken: res.data.security_token,
            region: "oss-cn-shenzhen",
            bucket: res.data.bucket,
          });
          self.uploadResult.file = e;
          // 回调函数的形式，在上传前判断图片或视频是否符合校验
          (self.uploadResult.start = function () {
            self.uploadResult.client
              .multipartUpload(self.prefix + e.file.name, e.file, {
                callback: {
                  url: self.callback.callback_url,
                  host: self.callback.callback_host,
                  body: self.callback.callback_body,
                  contentType: self.callback.callback_body_type,
                },
                progress(p: any, cpt: any) {
                  self.checkpoint = cpt;
                  if (p == 1) {
                    setTimeout(() => {
                      self.showProgress = false;
                    }, 500);
                  } else {
                    self.showProgress = true;
                    self.uploading = true;
                  }
                  self.percent = Number((p * 100).toFixed(0));
                  self.$emit("listen", self.percent);
                },
              })
              .then(function (result: any) {
                if (result.data.code == "Ok") {
                  self.$emit(
                    "update:originUrl",
                    self.cdn_url + "/" + result.data.object
                  );
                  self.$emit("change", {
                    name: result.data.object,
                    url: self.cdn_url + "/" + result.data.object,
                    type: self.type,
                  });
                }
              })
              .catch(function (err: any) {
                // console.log("put上传失败catch：", err);
                self.$message({
                  type: "warning",
                  message: "上传失败，请重新上传",
                });
                self.uploading = false;
                self.showProgress = false;
                self.uploadResult.client.abortMultipartUpload(
                  self.checkpoint.name,
                  self.checkpoint.uploadId
                );
              });

            // 监听文件上传进度
            // self.uploadResult.client
            //   .multipartUpload(self.prefix + e.file.name, e.file, {
            //     progress(p: any, cpt: any) {
            //       self.checkpoint = cpt;
            //       if (p == 1) {
            //         setTimeout(() => {
            //           self.showProgress = false;
            //         }, 500);
            //       } else {
            //         self.showProgress = true;
            //         self.uploading = true;
            //       }
            //       self.percent = Number((p * 100).toFixed(0));
            //       self.$emit("listen", self.percent);
            //       console.log("progress:" + p, new Date().getTime());
            //     },
            //   })
            //   .then((res: any) => {
            //     // console.log(res);
            //   })
            //   .catch((err: any) => {
            //     // console.log("上multipartUpload上传失败catch", err);
            //     self.$message({
            //       type: "warning",
            //       message: "上传失败，请重新上传",
            //     });
            //     self.uploading = false;
            //     self.showProgress = false;
            //   });
          }),
            self.$emit("selected", self.uploadResult);
        }
      })
      .catch((error: any) => {
        // console.log(error);
      });
  }
  beforeAvatarUpload(file: any) {
    if (file.type.includes("image")) {
      this.type = 1;
    } else if (file.type.includes("video")) {
      this.type = 2;
    } else if (file.type.includes("audio")) {
      this.type = 4;
      return false;
    }
    let typeArr: string[] = this.accept.split(",");
    let typePass: string[] = typeArr.filter((item: string) => {
      return file.name.indexOf(item) >= 0;
    });
    if (typePass.length === 0) {
      this.$message.error(`文件类型有误`);
      return false;
    }
    // let max = this.sizeLimit;
    // const pass = file.size / 1024 / 1024 < max;
    // if (!pass) {
    //   this.$message.error(`上传文件大小不能超过${max}MB!`);
    // }
    // return pass;
  }
  handleClear() {
    this.$emit("update:originName", "");
    this.$emit("update:originUrl", "");
    this.$emit("clear");
  }
}
